import { Outlet } from "react-router-dom";

const Users = () => <Outlet />;

export default Users;
